import React, { useState } from "react";
import { useQuote } from "../context/QuoteContext";
import { formatEur } from "../utils";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "./ui/command";
import { Check, ChevronsUpDown, Package } from "lucide-react";

// Searchable catalog selector: lets the operator override the AI-assigned catalog article.
// Each option shows the article label, its dimensions (cm) and its base monthly price.
export const CatalogPicker = ({ value, onSelect, allowNone = true, testid, className = "" }) => {
  const { catalog } = useQuote();
  const [open, setOpen] = useState(false);

  const dims = (c) => `${c.length_cm}×${c.width_cm}×${c.height_cm} cm`;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className={`inline-flex items-center gap-1 max-w-full text-[11px] text-slate-500 hover:text-[#1a5f5a] transition-colors ${className}`}
        >
          <span className="truncate">{value ? `→ ${value}` : "→ Scegli articolo"}</span>
          <ChevronsUpDown className="h-3 w-3 shrink-0 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0" align="start">
        <Command>
          <CommandInput placeholder="Cerca un articolo di catalogo…" data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList>
            <CommandEmpty>Nessun articolo trovato.</CommandEmpty>
            <CommandGroup>
              {allowNone && (
                <CommandItem
                  value="__none__ personalizzato nessuno"
                  onSelect={() => { onSelect(null); setOpen(false); }}
                  data-testid={testid ? `${testid}-none` : undefined}
                >
                  <Package className="h-4 w-4 text-slate-300" />
                  <span className="text-slate-500 italic">Nessuno (personalizzato)</span>
                  {!value && <Check className="ml-auto h-4 w-4 text-[#1a5f5a]" />}
                </CommandItem>
              )}
              {catalog.map((c) => (
                <CommandItem
                  key={c.label}
                  value={c.label}
                  onSelect={() => { onSelect(c); setOpen(false); }}
                  data-testid={testid ? `${testid}-opt-${c.label}` : undefined}
                >
                  <div className="min-w-0 flex-1">
                    <div className="text-sm text-slate-800 truncate">{c.label}</div>
                    <div className="text-[11px] text-slate-400">{dims(c)} · €{formatEur(c.price_eur)}/mese</div>
                  </div>
                  {value === c.label && <Check className="ml-2 h-4 w-4 text-[#1a5f5a] shrink-0" />}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
